import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type DeleteCrmIntegrationParams = {
  integrationId: string;
  organizationId: string;
};

export const deleteCrmIntegration = async (
  params: DeleteCrmIntegrationParams
): Promise<void> => {
  return await tinctApi.crmIntegrations.deleteCrmIntegration(params.integrationId);
};

export const useDeleteCrmIntegration = (
  options?: Omit<
    UseMutationOptions<void, ApiError, DeleteCrmIntegrationParams>,
    'mutationFn'
  >
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCrmIntegration,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['crm-integrations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['organization', args[1].organizationId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
